import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import CheckoutLinks from '@components/checkout/links';

import styles from './styles.module.scss';

type Props = {
  onCheckout?: boolean;
} & BaseComponentProps;

function TermsAndPrivacyLinks(props: Props) {
  const { onCheckout, containerStyle } = props;
  if (onCheckout) {
    return (
      <span className={clsx([styles.termsAndPrivacyLinks, containerStyle])}>
        By clicking the above button to make an inquiry or booking I agree to
        Rove’s{' '}
        <a
          target="_blank"
          href={CheckoutLinks.RENTAL_AGREEMENT}
          rel="noopener noreferrer"
        >
          Rental Agreement
        </a>
        ,{' '}
        <a
          target="_blank"
          href={CheckoutLinks.TERMS_OF_SERVICE}
          rel="noopener noreferrer"
        >
          Terms of Service, and Privacy Policy
        </a>
        , and agree to receive messages/notifications on my phone number.
      </span>
    );
  }

  return (
    <span className={clsx([styles.termsAndPrivacyLinks, containerStyle])}>
      By clicking <b>Sign Up and Continue</b>, I agree to <br /> Rove’s{' '}
      <a
        target="_blank"
        href={CheckoutLinks.TERMS_OF_SERVICE}
        rel="noopener noreferrer"
      >
        Terms of Service, and Privacy Policy
      </a>{' '}
      .
    </span>
  );
}

export default TermsAndPrivacyLinks;
